import { createRootRouteWithContext } from '@tanstack/react-router';

import { NotFoundPage } from '@/components/NotFoundPage';
import { RouterRoot } from '@/components/RouterRoot';
import type { RouterContext } from '@/router';
import { ErrorScreen } from '@/screens/app/ErrorScreen';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RouterRoot,
  errorComponent: ErrorScreen,
  notFoundComponent: NotFoundPage,
});
